import format from 'date-fns/format'

export default class Period {

  /**
   * Begin date and time.
   * String format has to be [YYYY-MM-ddTHH:mm].
   */
  public begin: string = format(new Date(), 'YYYY-MM-ddTHH:mm')

  /**
   * End date and time.
   * String format has to be [YYYY-MM-ddTHH:mm].
   */
  public end: string = format(new Date(), 'YYYY-MM-ddTHH:mm')
}
